const labels = {
  unavailable: '🔴 No rooms available',
  fragmented: '🟡🔄 Available with room changes',
  continuous: '🟢🔗 Available without room changes',
}

function availabilityLabel(value) {
  return labels[value] || 'Availability check pending'
}

function subscriptionReturnPath(value) {
  if (typeof value !== 'string') return null
  const path = '/hotel-management/availability-subscriptions'
  return value === path || new RegExp(`^${path}\\?subscription=[0-9a-f-]{36}$`, 'i').test(value) ? value : null
}

function newSubscriptionRequestId() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

module.exports = { availabilityLabel, subscriptionReturnPath, newSubscriptionRequestId }
